import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { VideoListComponent } from './components/video-list/video-list.component';
import { AnimeListComponent } from './components/anime-list/anime-list.component';
import { DelayResolve } from 'app/shared/delay.resolve';
import { PlayerComponent } from './components/player/player.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', component: AnimeListComponent, resolve: [DelayResolve] },
    { path: ':anime', component: VideoListComponent, resolve: [DelayResolve] },
    { path: ':anime/:episode', component: PlayerComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CoreRoutingModule { }
